import { CommonModule } from '@angular/common';
import { Component, Injectable, OnInit , forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController, NavController, NavParams } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { ImagePipe } from 'src/app/pipes/image/image';


@Injectable({providedIn: "root"})
@Component({
  selector: 'app-encontro-programacao',
  templateUrl: './encontro-programacao.page.html',
  styleUrls: ['./encontro-programacao.page.scss'], 
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    SemRegistroComponent
  ],
})
export class EncontroProgramacaoPage implements OnInit {
  programacao: any = {tipo:{}, responsaveis: []};
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public modalCtrl: ModalController,
    ) {
    this.programacao = this.navParams.get('programacao');
  }

  ngOnInit() {
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
